import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type Props = {
  hotelId: number;
  isLegacy: boolean;
};

export const useEntityNavigation = ({ hotelId, isLegacy }: Props) => {
  const history = useHistory();
  const location = useLocation();

  const backState = useMemo(
    () => ({ pathname: location.pathname + location.search }),
    [location]
  );

  const goToCreateRoom = useCallback(() => {
    history.push({
      pathname: '/rooms/new',
      search: `?hotelId=${hotelId}`,
      state: backState,
    });
  }, [history, backState, hotelId]);

  const goToCreateActivity = useCallback(() => {
    history.push({
      pathname: '/activities/new',
      search: `?hotelId=${hotelId}`,
    });
  }, [history, hotelId]);

  return {
    goToCreateRoom,
    goToCreateActivity,
  };
};
